module.exports = __webpack_public_path__ + "static/media/md-remove.5aaa4115.svg";